import React, { useState, useEffect } from "react";
import NextICon from "../../images/icons/next.svg";
import PrevICon from "../../images/icons/prev.svg";
import "./ScrollerStyles.css";
import $ from "jquery";

export default function ScrollerWithArrows(props) {
  const scrollerStyles = {
    display: "flex",
    flexDirection: "row",
    width: props.width,
  };

  const firstArrowStyles = {
    position: "relative",
    top: "5rem",
    left: 0,
    zIndex: 999,
    cursor: "pointer",
    width: "fit-content",
    height: "fit-content",
    marginRight: "-8%",
  };

  const secondArrowStyles = {
    position: "relative",
    top: "5rem",
    left: 0,
    zIndex: 999,
    cursor: "pointer",
    width: "fit-content",
    height: "fit-content",
    marginLeft: "-8%",
  };

  const scrolling = (parentId, childId, side) => {
    const el = document.getElementById(props?.children?.ref?.current?.id);

    if (side === "right") {
      el.scrollLeft += 150;
    } else {
      el.scrollLeft -= 150;
    }

    setTimeout(() => {
      let position = $(`#${childId}-0`).offset();

      let lastPosition = $(`#${childId}-${props?.lastIndex}`).offset();

      let isShowLastone = Math.abs(
        $(`#${parentId}`).width() - lastPosition?.left
      );

      console.log("isShowLastone", position, isShowLastone);

      if (position.left < 0) {
        props.setShowLeft(true);
      } else {
        props.setShowLeft(false);
      }

      if (
        isShowLastone > props.minimumValue &&
        isShowLastone < props.maximumValue
      ) {
        props.setShowRight(false);
      } else {
        props.setShowRight(true);
      }
    }, 500);
  };

  return (
    <div style={scrollerStyles} className="ScrollerWithArrows">
      {props?.children && props?.isShowLeft && !props?.dontShow ? (
        <img
          style={firstArrowStyles}
          id="arrowScroller"
          src={PrevICon}
          onClick={(e) => scrolling(props.parentId, props.childId, "left")}
          alt="left"
        />
      ) : null}

      {props.children}

      {props?.children && props?.isShowRight && !props?.dontShow ? (
        <img
          style={secondArrowStyles}
          id="arrowScroller"
          src={NextICon}
          onClick={(e) => scrolling(props.parentId, props.childId, "right")}
          alt="right"
        />
      ) : null}
    </div>
  );
}
